import React, { Component } from 'react';
import * as util from '../../../../../utils/EnumMapping';
import MainTable from '../../../../common/table/MainTable';
import NewRestrainPartner from './NewRestrainPartner';
import * as columns from './RestrainPartnerColumns';
import { tabs } from '../RestrainUtil';
import LinkTab from '../../../../common/tab/TabNav.js';

class RestrainPartner extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "RESTRAIN_PARTNER";
            item.state = util.getSecondValue(util.activeStates, item.active);
            item.stateLabel = util.getLabel(util.activeStates, item.active);
            return item;
        })
        return data;
    }

    render() {
        return (
            <>
                <LinkTab tabs={tabs} index={1} />
                <MainTable
                    divClassName="restrain-partner"
                    tableName="Letiltásos partnerek"
                    newObjectLabel="Új letiltás partner hozzáadása"
                    path='/api/restrainpartners'
                    enrich={this.enrich}
                    columns={(refresh) => columns.columns(refresh)}
                    dialogContent={(refresh, close) => <NewRestrainPartner refresh={refresh} close={close} />} />
            </>
        );
    }
}

export default RestrainPartner;